import { Label as MuiLabel, LabelOff as MuiLabelOff } from '@material-ui/icons'
import React from 'react'
import styled from 'styled-components'

const StyledLabelIcon = styled(MuiLabel)`
  color: ${({ theme }) => theme.colors.brand.categoryGreen};
  transform: scale(-1, 1);
`

const StyledLabelOffIcon = styled(MuiLabelOff)`
  color: ${({ theme }) => theme.colors.brand.categoryOrange};
  transform: scale(-1, 1);
`

export interface LabelStatusIconProps {
  className?: string
  isLabelPresent: boolean
}

const LabelStatusIcon: React.FC<LabelStatusIconProps> = ({ className, isLabelPresent }) =>
  isLabelPresent ? (
    <StyledLabelIcon
      className={className}
      titleAccess="You have a label on file with us for this item."
    />
  ) : (
    <StyledLabelOffIcon
      className={className}
      titleAccess="You do not have a label on file with us for this item."
    />
  )

export default LabelStatusIcon
